// old version DO NOT USE
const BoardMember22 = ({ member }) => {
    return (
        <>
            <div className="profile-pic-dropdown">
                <img src={member.imageSrc} alt={member.name} width="100%" />
                <h2>{member.position}</h2>
                <p>{member.name}</p>
                <p>{member.major} {member.gradYear}</p>
            </div>
        </>
    );
};
export default BoardMember22;